<template>
  <div class="mt-5" v-if="game">
    <template v-if="game.playerInfo.length > 1">
      <h6><span v-if="getPlayerInfo(otherPlayer).captures > 0">Captured {{ getPlayerInfo(otherPlayer).captures }} piece<span v-if="getPlayerInfo(otherPlayer).captures > 1">s</span></span>&nbsp;</h6>
      <time-left :miliseconds="getPlayerInfo(otherPlayer).timeLeft"></time-left>
      <timebar :time-left="getPlayerInfo(otherPlayer).timeLeft" :total-time="game.duration" position="top"></timebar>
    </template>
    <div class="gamecontrols--box text-light-insignificant">
      <template v-if="game.players.length > 1">
        <h5 class="ml-2 mt-2 pt-1"><Username offline-class="text-light-insignificant" :username="game.getPlayer(otherPlayer).username" :uid="game.getPlayer(otherPlayer).uid"></Username></h5>
      </template>
      <moves :list="game.moves" :move-index="game.moves.length - 1"></moves>
      <!-- <moves :list="game.moves" :move-index="clientSideData.moveIndex"></moves> -->
      <div class="p-2" v-if="game.finished">
        <a v-if="config.rematch && !config.rematch.offered && typeof config.rematch.accepted === 'undefined'" class="btn btn-light" href="#" @click.prevent="offerRematch">Offer Rematch</a>
        <button v-if="config.rematch && config.rematch.offered && typeof config.rematch.accepted === 'undefined'" class="btn text-white" href="#">Rematch Offered</button>
        <template v-if="config.rematch && typeof config.rematch.accepted !== 'undefined'">
          <button class="btn text-white" href="#" v-if="!config.rematch.accepted">Rematch Declined</button>
          <button class="btn text-white" href="#" v-if="config.rematch.accepted">Rematch Accepted</button>
        </template>
        <template v-if="config.rematch && config.rematch.offered && config.rematch.by !== getCurrentUser.uid && typeof config.rematch.accepted === 'undefined'">
          <a class="btn btn-light mr-2" @click.prevent="acceptRematch" href="#">Accept</a>
          <a class="btn btn-outline-light" @click.prevent="declineRematch" href="#">Decline</a>
        </template>
      </div>
      <h5 class="ml-2 mt-2 pt-1"><Username :username="game.getPlayer(currentPlayer).username" :uid="game.getPlayer(currentPlayer).uid"></Username></h5>
    </div>
    <timebar :time-left="getPlayerInfo(currentPlayer).timeLeft" :total-time="game.duration" position="bottom"></timebar>
    <time-left :miliseconds="getPlayerInfo(currentPlayer).timeLeft"></time-left>
    <h6><span v-if="getPlayerInfo(currentPlayer).captures > 0">Captured {{ getPlayerInfo(currentPlayer).captures }} piece<span v-if="getPlayerInfo(currentPlayer).captures > 1">s</span></span>&nbsp;</h6>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Moves from '@/components/Moves.vue';
import TimeLeft from '@/components/TimeLeft.vue';
import Timebar from '@/components/Timebar.vue';
import Username from '@/components/Username.vue';

export default {
  components: {
    Moves,
    TimeLeft,
    Timebar,
    Username,
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'getCurrentUser', 'getUserData']),
    currentPlayer() {
      return this.game.players.find(p => p.uid === this.getCurrentUser.uid).uid;
    },
    otherPlayer() {
      return this.game.players.find(p => p.uid !== this.getCurrentUser.uid).uid;
    },
  },
  methods: {
    offerRematch() {
      this.$root.$emit('offer-rematch', { by: this.getCurrentUser.uid });
    },
    acceptRematch() {
      this.$root.$emit('accept-rematch', { accepted: true });
    },
    declineRematch() {
      this.$root.$emit('decline-rematch', { accepted: false });
    },
    getPlayer(uid) {
      return this.config.players.find(p => p.uid === uid);
    },
    getPlayerInfo(uid) {
      return this.game.playerInfo.find(pi => pi.player === uid);
    },
  },
  name: 'GameControls',
  props: ['game', 'config', 'clientSideData'],
};
</script>

<style lang="scss" scoped>
  .gamecontrols--box {
    border: 1px solid rgba(0,0,0,0.6);
    background: #262421;
    border-radius: 0 5px 5px 0;
    position: relative;
    z-index: 5;
  }
</style>
